import { createI18n } from 'vue-i18n'
import { useLocalStorage } from '@vueuse/core'
// import zhCH from './language/zh-ch'
import en from './language/en'
import zhTW from './language/zh-TW'
import ar from './language/ar'

import de from './language/de'
import es from './language/es'
import fr from './language/fr'
import it from './language/it'
import ru from './language/ru'
import th from './language/th'
import tr from './language/tr'


/**
 * Amount formatting
 */
export function formatAmountFunc(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}


const langRef = useLocalStorage('language', 'en')

const messages = { en,ar,de,es,fr,it,ru,th,tr,zhTW }

const i18n = createI18n({ locale: langRef.value, messages })

const languageList = Object.keys(messages).map(k =>
  ({ label: messages[k].title, value: k })
)

const setLanguage = (item = { label: '', value: '' }) => {
  i18n.locale = item.value
  langRef.value = item.value
  setTimeout(() => {
    location.reload()
  }, 500);
}

const t = i18n.global.t

const moneyFlag = process.env.VUE_APP_MONEY_FLAG

const fm = (money) => {
  let _val = formatAmountFunc(parseFloat(money||0).toFixed(2))
  return `${moneyFlag} ${_val}`
}

const fn = (money) => {
  let _val = formatAmountFunc(parseFloat(money||0).toFixed(2))
  return _val
}

export default i18n
export { t, langRef, languageList, setLanguage, fm, fn }
